import { INGESTION_EVENT_ROOT } from '../../Ingestion/IngestionLayout/helpers';

export const splitChar = '-';
export const evt = 'evt';
export const evtSplitChar = `${splitChar}${evt}${splitChar}`;

export const TREE_ID_PREFIXES = {
  splitChar,
  root: INGESTION_EVENT_ROOT,
  tripples: 'triples',
  dataSource: `ds${evtSplitChar}`,
  table: `table${evtSplitChar}`,
  segment: `segment${evtSplitChar}`,
  files: 'files',
  tables: `table${evtSplitChar}direct${splitChar}`,
  timeseries: `timeseries`,
  ts: `ts${splitChar}`,
};
